import { AxiosInstance } from 'axios';
import { Lesson } from './types';

export function lessonsApi(client: AxiosInstance) {
  return {
    getList: (moduleId: number) =>
      client.post<{ items: Lesson[] }>('/api/v1/admin/lessons/get-list', { moduleId }),
    getById: (id: number) =>
      client.post<Lesson>('/api/v1/admin/lessons/get-by-id', { id }),
    create: (data: Omit<Lesson, 'id'>) =>
      client.post<Lesson>('/api/v1/admin/lessons/create', data),
    update: (data: Lesson) =>
      client.post<Lesson>('/api/v1/admin/lessons/update', data),
    reorder: (moduleId: number, items: { id: number; sortOrder: number }[]) =>
      client.post<{ items: Lesson[] }>('/api/v1/admin/lessons/reorder', { moduleId, items }),
    batchDelete: (ids: number[]) =>
      client.post<{ deleted: number[] }>('/api/v1/admin/lessons/batch-delete', { ids }),
    batchUpdateBodies: (items: { id: number; body: unknown }[]) =>
      client.post<{ items: Lesson[] }>('/api/v1/admin/lessons/batch-update-bodies', { items }),
  };
}
